import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// Components
import AppHeader from 'components/AppHeader';
import AppSidebar from 'components/AppSidebar';
import SidebarLayout from 'components/SidebarLayout';
import AcceptOwnerRoleDialog from 'components/AcceptOwnerRoleDialog';
import FreeTrialBanner from 'components/FreeTrialBanner/FreeTrialBanner';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

/**
 * The CoreLayout is meant to be the top application
 * layout for almost every page. It contains all of our core
 * common components for the UI.
 */
function CoreLayout({ classes, children }) {
  const [bannerOpen, setBannerOpen] = useState(true);
  const client = useSelector(state => state.client);
  const trialEndDate = client.trialEndDate
    ? moment(client.trialEndDate)
    : moment(client.assignedAt).add(14, 'days');
  const currentDay = moment(new Date());

  const trialDaysRemaining = trialEndDate.diff(currentDay, 'days');

  const handleClose = () => {
    setBannerOpen(false);
  };

  return (
    <SidebarLayout
      classes={{
        root: classes.root,
        sidebarContent: classes.sidebarContent,
      }}
    >
      {client.isTrial && bannerOpen && trialDaysRemaining >= 0 && (
        <FreeTrialBanner trialDaysRemaining={trialDaysRemaining} onClose={handleClose} />
      )}
      <AppSidebar />
      <AppHeader />
      <AcceptOwnerRoleDialog />
      <div className={classes.childrenContainer}>{children}</div>
    </SidebarLayout>
  );
}

CoreLayout.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
};

const styles = theme => {
  return {
    root: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'row',
      overflowY: 'hidden',
      overflowX: 'hidden',
      background: theme.colors.contentBgColor,
    },
    sidebarContent: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflow: 'hidden',
    },
    childrenContainer: {
      marginLeft: theme.overrides.AppSidebar.width,
      overflowX: 'auto',
      display: 'flex',
      flex: '1 1 auto',
    },
  };
};

export default withStyles(styles)(CoreLayout);
